<template>
	<div>
		<v-img
			contain
			:width="width"
			:height="height"
			:src="getThumbnailUrl()"
			@click="openCadDialog()"
			title="Cad öffnen"
			style="cursor: pointer"
		></v-img>
		<v-dialog v-if="cadDialog" v-model="cadDialog" content-class="specialSize" persistent>
			<div style="background-color: #f3f3f4; padding: 0px; margin 0px">
				<iframe
					v-if="cadDialog"
					loading="lazy"
					:height="currentWindowHeight"
					:src="articleCadViewUrl"
					style="padding: 0px; margin: 0px; border: 0px; width: 100%"
				>
				</iframe>
			</div>
		</v-dialog>
	</div>
</template>

<script>
import httpClient from "../store/httpClient";
export default {
	props: {
		articleId: 0,
		width: "",
		height: "",
		readonly: false,
	},
	data() {
		return {
			cadDialog: false,
			articleHasUnsavedChanges: false,
			currentWindowHeight: "100px",
			articleToken: null,
			cadViewTick: 0,
		};
	},
	mounted() {
		this.setWindowHeight();
		window.addEventListener("resize", (event) => {
			this.setWindowHeight();
		});
	},

	methods: {
		getThumbnailUrl() {
			return `${process.env.VUE_APP_erpUrl}article/getthumbnail?id=${this.articleId}&time=${this.articleLastChange}`;
		},
		setWindowHeight() {
			// 165 besteht aus...
			// - Margins der Dialogbox (variieren etwas je nach Aspect Ratio)
			// - Buttons für Speichern / Schliessen im Dialogfenster
			// - Sicherheitsmarge, sodass sicher keine Scrollbar im Dialog erscheint
			const currentHeight = window.innerHeight - 65;
			this.currentWindowHeight = `${currentHeight}px`;
		},
		async openCadDialog() {
			if (!this.cadDialog) {
				try {
					const response = await httpClient().get(
						`api/artikel/GetArticleToken?blexonArtikelId=${this.articleId}&isWritable=${!this.readonly}`
					);
					this.articleToken = response.data;
					if (this.articleToken != null) {
						// One fresh tick per opening. See articleCadViewUrl for why it must not be
						// generated inside the computed.
						this.cadViewTick = Date.now();
						window.addEventListener("message", this.handleArticleChangedInCad);
						this.cadDialog = true;
					}
				} catch (err) {
					console.log(`Für den Artikel konnte kein Token geladen werden. Error: ${err}`);
				}
			} else {
				this.cadDialog = false;
			}
		},

		/**
		 * This event handler is called, when the cad article in the iframe has changed.
		 */
		async handleArticleChangedInCad(event) {
			if (
				event.origin == "https://cad.test.blexon.com" ||
				event.origin == "https://cad.blexon.com" ||
				event.origin == "https://cam.blexon.com" ||
				event.origin == "https://cam.test.blexon.com" ||
				event.origin == "http://localhost:8180" ||
				event.origin == "http://localhost:8185"
			) {
				await this.closeCadDialog();
			}
		},

		async closeCadDialog() {
			window.removeEventListener("message", this.handleArticleChangedInCad);
			await httpClient().post(`api/artikel/DeleteToken?token=${this.articleToken.token}`);
			this.articleToken = null;
			this.cadDialog = false;
		},
	},
	computed: {
		articleCadViewUrl() {
			let localToken = "";
			if (this.articleToken !== null) {
				localToken = this.articleToken.token;
			}
			// The cache buster has to sit BEFORE the "#": everything after it is a URL fragment,
			// which the browser neither sends to the server nor uses as part of its cache key.
			// Without it the browser keeps serving a stale index.html from its cache, together with
			// the stale (hashed) asset references.
			// The language stays behind the hash, where the cam client reads it from the route
			// query. The fertigerportal itself is German only, so it passes the cam client's
			// default explicitly instead of relying on its silent fallback.
			//
			// The tick is taken once per dialog opening (see openCadDialog) and must NOT be
			// generated here: a computed is re-evaluated whenever one of its reactive dependencies
			// changes, and a new tick before the "#" reloads the whole iframe instead of just
			// changing its fragment. Every such reload fires the viewer's beforeunload handler,
			// whose Close deletes the cam working directory of the token.
			const [origin, route = "/"] = String(process.env.VUE_APP_CAM_CLIENT_URL).split("#");
			return (
				`${origin}?tick=${this.cadViewTick}#${route}` +
				`${this.articleId}/${localToken}` +
				`?language=de-CH`
			);
		},
	},
};
</script>
